import React, { useEffect, useState } from 'react';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import styles from './FormNpde.module.scss';
import FormModal from './form-modal/FormModal';
import { useFetch } from 'hooks/useFetch';
import { workflow } from 'hooks/endpoints';
import { useParams } from 'react-router-dom';
import FormPreview from '../../forms/form/formPreview/FormPreview';
const FormNode = ({ id, selected }) => {
  const { id: workflowId } = useParams();

  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isError, setIsError] = useState(node?.is_Error || false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [applicationName, setApplicationName] = useState(null);
  const { data: formDropDownList, isPending } = useFetch(
    ['getFormsByWorkflowId', id],
    workflow.getFormsByWorkflowId(workflowId)
  );

  useEffect(() => {
    if (node?.form?.formId) {
      setApplicationName(
        formDropDownList?.data?.find((item) => item.value == node?.form?.formId)
          ?.label
      );
    }
  }, [node?.form?.formId, formDropDownList]);

  useEffect(() => {
    if (node?.form) {
      if (!applicationName) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.form, applicationName]);

  return (
    <>
      <NodeContainer
        id={id}
        name={node?.title ?? 'Form Block'}
        backgroundColor={node?.color}
        selected={selected}
        onClick={() => setIsModalOpen(true)}
        node={node}
        isError={isError}
      >
        <Handle
          type='target'
          position={Position.Left}
          className='custom-handle'
        />
        <div className={styles.cont}>
          <div className={styles.details}>
            {' '}
            <SvgWithBranding type='node-form' color='#787878' />
            {node?.form?.formId ? (
              <p>{applicationName}</p>
            ) : (
              <p className={styles.placeholder}>Select Form</p>
            )}
          </div>
          {node?.form?.formId ? (
            <FormPreview formId={node?.form?.formId} isNode disabled />
          ) : null}
        </div>

        <Handle
          type='source'
          position={Position.Right}
          className='custom-handle'
        />
      </NodeContainer>
      <FormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='Form'
        id={node.id}
        isError={isError}
      />
    </>
  );
};

export default FormNode;
